export interface Styles {
  StrokeColor: string;
  FillValidColor: string;
  FillInvalidColor: string;
  FontColor: string;
  Font: string;
}

export const DefaultStyles: Styles = {
  StrokeColor: '#457b9d',
  FillValidColor: '#a8dadc',
  FillInvalidColor: '#e63946',
  FontColor: '#f1faee',
  Font: '24px Consolas',
};
